import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  TextField,
  Grid,
  Card,
  CardMedia,
  Stack,
  InputAdornment,
  Chip,
} from "@mui/material";
import { BsSearch } from "react-icons/bs";
import TemplateData from "./TemplateData/TemplateData";
import { useNavigate } from "react-router-dom";

const SelectFieldSection = () => {
  const [cards, setCards] = useState([]); // Stores filtered templates
  const [chips, setChips] = useState([]); // Holds filter chips
  const [searchQuery, setSearchQuery] = useState(""); // Manages search bar input
  const navigate = useNavigate();
  const gridContainerRef = useRef(null);

  //  Updates the search query from input
  const handleInputChange = (event) => {
    setSearchQuery(event.target.value.toLowerCase());
  };

  //  Filters templates based on search term (template name or description)
  const fetchTemplates = async () => {
    try {
      const filtered = TemplateData.filter((item) => {
        return (
          searchQuery === "" ||
          item.temp_name.toLowerCase().includes(searchQuery) ||
          item.description.toLowerCase().includes(searchQuery)
        );
      });
      setCards(filtered);
    } catch (error) {
      console.error("Error fetching templates:", error);
    }
  };

  //  Fetch templates whenever search query changes
  useEffect(() => {
    fetchTemplates();
  }, [searchQuery]);

  //  Navigate to template detail on card click
  const handleCardClick = (card, index) => {
    navigate(card.path, { state: { card, index } });
  };

  //  Optional: Clear chip if needed (no chip UI used in this minimal version)
  const handleChipDelete = (chipType) => {
    setChips((prev) => prev.filter((chip) => chip.type !== chipType));
  };

  return (
    <Box sx={{ padding: "20px", width: { xl: "76%", lg: "95%", md: "98%" } }}>
      {/*  Search Bar */}
      <TextField
        variant="outlined"
        placeholder="Search Templates..."
        size="small"
        value={searchQuery}
        onChange={handleInputChange}
        sx={{
          backgroundColor: "white",
          width: { xl: "30%", lg: "30%", md: "30%", sm: "25%", xs: "100%" },
          borderRadius: "8px",
          mb: 2,
        }}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <BsSearch />
            </InputAdornment>
          ),
        }}
      />

      {/*  Filter Chips (not actively used in this example but placeholder is here) */}
      <Stack direction="row" spacing={1} sx={{ mb: 2 }}>
        {chips.map((chip) => (
          <Chip
            key={chip.type}
            label={`${chip.type}: ${chip.label}`}
            onDelete={() => handleChipDelete(chip.type)}
            sx={{
              backgroundColor: "white",
              color: "black",
              border: "1px solid white",
              "& .MuiChip-deleteIcon": { color: "black" },
            }}
          />
        ))}
      </Stack>

      {/*  Card Grid Display */}
      <Box ref={gridContainerRef} sx={{ position: "relative", height: "auto" }}>
        {cards.length === 0 ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100%",
              color: "#666",
              fontSize: { xl: "48px", lg: "48px", sm: "38px", xs: "28px" },
              fontWeight: "bold",
              paddingTop: "100px",
            }}
          >
            No Data Found
          </Box>
        ) : (
          <Grid container spacing={{ xl: 2, lg: 2, md: 2, sm: 2, xs: 2 }}>
            {cards.map((card, index) => (
              <Grid item xs={6} sm={6} md={4} lg={3} xl={3} key={index}>
                <Card
                  elevation={0}
                  sx={{
                    position: "relative",
                    overflow: "hidden",
                    backgroundColor: "transparent",
                    cursor: "pointer",
                    border: "transparent",
                    boxShadow: "none",
                  }}
                  onClick={() => handleCardClick(card, index)}
                >
                  <CardMedia
                    component="img"
                    sx={{
                      height: {
                        xl: "496px",
                        lg: "440px",
                        sm: "440px",
                        xs: "320px",
                      },
                      width: "100%",
                      objectFit: "contain",
                      borderRadius: "16px 16px 0 0",
                    }}
                    image={card.image}
                    alt={card.title}
                  />
                </Card>
              </Grid>
            ))}
          </Grid>
        )}
      </Box>
    </Box>
  );
};

export default SelectFieldSection;